export default __webpack_public_path__ + "static/media/heart.6c3d8a4f.svg";